import React from "react";
import Page from "../../common/page/Page";
import JobDashboardBlock from "./JobDashboardBlock";
import useQueryJobById from "../../jobs/view/useQueryJobById";
import { useParams } from "react-router";
import WaitForData from "../../common/data-fetching/WaitForData";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized";
import ReportProblemOutlined from "@material-ui/icons/ReportProblemOutlined";
import useTranslationJobDashboard from "../useTranslationJobDashboard";
import useShowLoader from "../../common/loading-widgets/useShowLoader";

export default function JobDashboardPage(props) {
  // Fetch job from ID provided in the url params.
  const { t, loading: tLoading } = useTranslationJobDashboard();
  useShowLoader(tLoading, "JobDashboardPage");

  const urlParams = useParams();
  const jobId = urlParams.jobId;
  const {
    data: job,
    loading: jobLoading,
    errors: jobErrors,
  } = useQueryJobById(jobId);

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <WaitForData
          loading={jobLoading}
          errors={jobErrors}
          onError={() => <ReportProblemOutlined className="LoadingError" />}
          onLoaded={() => (
            <Page className="JobCandidatesPage">
              {!job && (
                <>
                  <Page.Title>
                    {t("job-dashboard:job_dashboard_deleted_job_msg")}
                  </Page.Title>
                </>
              )}
              {job && (
                <>
                  <Page.Title>{job.title}</Page.Title>
                  <Page.Content>
                    <JobDashboardBlock job={job} />
                  </Page.Content>
                </>
              )}
            </Page>
          )}
        />
      )}
    />
  );
}
